export const ViewItem = ({
  icon,
  title,
  subTitle,
  link
}: {
  icon: any;
  title: string;
  subTitle: string;
  link?: string;
}) => {
  const Icon = icon;
  return (
    <>
      <div className="mb-2 px-2">
        <div className="text-center mt-3">
          <Icon className="text-primary" size="32" />
          <div className="pair-name mt-2">{title}</div>
          <div className="pair-value">{subTitle}</div>
        </div>
      </div>
    </>
  );
};
